import { useMutation } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";

export interface StandardsSetRelationPayload {
  id: string;
}

interface AddStandardsSetRelationProps {
  standardsSetId: string;
  currentNumberOfStandardsInSet: number;
  standardId: string;
}

export const useAddStandardsSetRelation = () => {
  return useMutation<
    StandardsSetRelationPayload,
    Error,
    AddStandardsSetRelationProps
  >({
    mutationFn: async ({
      standardsSetId,
      currentNumberOfStandardsInSet,
      standardId,
    }: AddStandardsSetRelationProps): Promise<StandardsSetRelationPayload> => {
      const payload = {
        target_id: standardId,
        display_order: currentNumberOfStandardsInSet,
        relation_type: "CHILD",
        data: {},
      };

      const response = await api().post<StandardsSetRelationPayload>(
        `${ApiCatalog.draftContent.endpoint}${standardsSetId}/content-relation/`,
        payload,
      );
      return response;
    },
  });
};
